import { createFileRoute, redirect } from '@tanstack/react-router';
import { useSelfServiceAuth } from '@/stores/selfServiceAuth';

export const Route = createFileRoute('/$tenantId/self-service/')({
  beforeLoad: async ({ params }) => {
    const { isTokenValid } = useSelfServiceAuth.getState();

    if (isTokenValid()) {
      throw redirect({
        to: '/$tenantId/self-service/dashboard',
        params: { tenantId: params.tenantId },
      });
    }

    throw redirect({
      to: '/$tenantId/self-service/login',
      params: { tenantId: params.tenantId },
    });
  },
});
